<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MICkQv/tc-custom/9781453220566.jpg?1733085767787" alt="This image is the cover for the book Silent Thunder, The Amos Walker Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Silent Thunder, The Amos Walker Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>Detroit PI Amos Walker attempts to clear the name of a woman accused of murdering her husband</b>Constance Thayer probably isn’t a nice woman. If she was, she wouldn’t have shot her husband to death. But just because she has a taste for nightlife—drinking, clubbing, and the finest hard drugs—doesn’t mean her husband didn’t deserve it. An automobile magnate in a city where internal combustion still reigns supreme, Doyle Thayer Jr. was a wife-beater with a collection of assault weapons that could furnish an army. At least that’s the story spun by Amos Walker’s new client, a large investigatory outfit hired by Mrs. Thayer to clear her name. Walker’s job is to get the dirt on her late husband, to learn enough about him that her shooting looks like an act of heroism. And please, his new bossbegs, don’t make any waves—a sure sign that the man doesn’t know Amos Walker. This ebook features an illustrated biography of Loren D. Estleman including rare photos from the author’s personal collection.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Loren D. Estleman
      </h2>
      
      <p class="authorDescription body article">Loren D. Estleman (b. 1952) has written over sixty-five novels. His most enduring character, Amos Walker, made his first appearance in 1980&rsquo;s <i>Motor City Blue</i>, and the hardboiled Detroit private eye has been featured in twenty books since. Estleman has also won praise for his adventure novels set in the Old West, receiving awards for many of his standalone westerns. In 1993 Estleman married Deborah Morgan, a fellow mystery author. He lives and works in Ann Arbor, Michigan. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4f17682c